import React from "react";
import TableLiterature from "../../components/TableLiterature/TableLiterature";

const Literature = () => {
  return (
    <div>
      <div className="pt-[80px] md:pt-0 px-2 md:px-6 m-2 md:m-10 bg-white rounded-3xl">
        <p className="text-xl mb-4 text-left">Lista e literaturave</p>
        <TableLiterature />
      </div>
    </div>
  );
};

export default Literature;
